import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import RoomAPI from "../RoomAPI";
import { updateStreamers } from "../redux/slices/meta";

export const useTwitchStreamers = () => {
  const dispatch = useAppDispatch();
  const streamers = useAppSelector((state) => state.meta.streamers);

  const update = useCallback(() => {
    RoomAPI.GetTwitchUsers().then((s) => dispatch(updateStreamers(s)));
  }, [dispatch]);

  useEffect(() => {
    update();
    const interval = setInterval(update, 300000); // 5 minutes

    return () => {
      clearInterval(interval);
    };
  }, [update]);

  return streamers;
};
